<template>
  <div class="w-full">
    <v-form
      ref="ambassadorForm"
      v-model="isFormValid"
      name="ambassador-data"
      @change="error = ''"
    >
      <v-row class="ma-0 pa-0 mb-2">
        <v-text-field
          id="contact_person_system_name"
          ref="name"
          v-model.lazy="ambassadorData.name"
          variant="outlined"
          :label="$t('labels.name')"
          placeholder="Max Makler"
          :loading="isLoading.name"
          @click="onClick('Name', ambassadorData.name)"
          @update:model-value="(val) => update('name', val, 'Name')"
        />
      </v-row>
      <v-row class="ma-0 pa-0 mb-2">
        <PhoneField
          v-model="ambassadorData.phone"
          :loading="isLoading.phone"
          update-on-input
          @update:model-value="(val) => update('phone', val, 'Country Calling Code')"
        />
      </v-row>

      <v-row class="ma-0 pa-0 mb-2">
        <v-text-field
          ref="email"
          v-model.lazy="ambassadorData.email"
          class="pt-6"
          type="email"
          variant="outlined"
          :label="$t('labels.email')"
          placeholder="info@max-makler.de"
          :rules="[rules.email]"
          :loading="isLoading.email"
          @click="onClick('E-Mail Address', ambassadorData.email)"
          @update:model-value="(val) => update('email', val, 'E-Mail Address')"
        />
      </v-row>
    </v-form>
  </div>
</template>
<script>
import PhoneField from '@/components/PhoneField.vue'
import featureNames from '@/lib/featureNames'
import { email } from '@/lib/validation'

export default {
  components: { PhoneField },
  props: {
    ambassador: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      ambassadorData: { ...this.ambassador },
      debounceTimeout: null,
      spinnerTimeout: null,
      isLoading: {
        name: false,
        phone: false,
        email: false,
      },
      isFormValid: false,
    }
  },
  watch: {
    ambassador() {
      this.ambassadorData = { ...this.ambassador }
    },
  },
  created() {
    this.rules = { email }
    this.featureNames = featureNames
  },
  unmounted() {
    clearTimeout(this.spinnerTimeout)
    clearTimeout(this.debounceTimeout)
  },
  methods: {
    onClick(label, value) {
      this.$tracking.event('Settings', 'Clicked', label, value)
    },
    async update(name, value, label) {
      this.ambassadorData[name] = value
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.isLoading[name] = true
        this.spinnerTimeout = setTimeout(async () => {
          const { valid } = await this.$refs.ambassadorForm.validate()
          if (valid) {
            this.$emit('saveSettings', { ...this.ambassadorData })
            this.$tracking.event('Settings', 'Edited', label)
          }
          this.isLoading[name] = false
        }, 1000)
      }, 2000)
    },
  },
  emits: ['saveSettings'],
}
</script>
